import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReturnToComponent} from './return-to.component';
import {ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {DropdownModule} from '../../../directives/dropdown/dropdown.module';


@NgModule({
  declarations: [ReturnToComponent],
  imports: [
    NgbModule,
    UrlModule,
    RouterModule,
    I18nModule,
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ReturnToComponent: {
          component: ReturnToComponent,
        }
      }
    }),
    DropdownModule,
  ],
  exports: [
    ReturnToComponent
  ]
})
export class ReturnToModule {
}
